import { useEffect, useState } from 'react'

/**
 * This is a utility hook used to solve a very bad buggy issue.
 * In some places we have html so broken up that is localize won't
 * automatically capture the text. In order to solve this we can
 * just call window.Localize.translate on them and it will work,
 * 100% of the time.
 *
 * Problem is, because we translate manually with a function call,
 * if the user changes language via the menu it wont rerun the
 * translation function in our component so that part wont
 * change language.
 *
 * With this hook we add an event listener to the setLanguage
 * event and trigger a rerender inside whatever component this
 * hook is in.
 *
 * It should be used sparingly.
 */
function useRerenderOnSetLanguage() {
  const [, forceUpdate] = useState(0)

  useEffect(() => {
    const handler = () => forceUpdate((v) => v + 1)
    window?.Localize?.on?.('setLanguage', handler)

    return () => {
      window?.Localize?.off?.('setLanguage', handler)
    }
  }, [])
}

export default useRerenderOnSetLanguage
